import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import _ from 'underscore';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { findCurrentMenu } from '@/utils/helpers';
import { useSelector } from 'react-redux';
import { dummyMenu } from '@/modules/mobility-console/pages/settings/index-const';
import _1 from 'lodash';
export var Breadcrumbs = function (_a) {
    var _b;
    var menuGroup = _a.menuGroup;
    var t = useTranslation('translation').t;
    var id = useSelector(function (state) { return state.menuUser; }).id;
    var theme = useTheme();
    var location = useLocation();
    var currentLink = [];
    var crumb;
    var menus = _.pluck(menuGroup, 'items').flat(1);
    var renderBreadcrumbLink = function (crumb, crumbName, currentLink) {
        return (_jsx(Link, { id: "".concat(crumbName, "_breadcrumb"), to: currentLink.join('/'), style: { textDecoration: 'none' }, children: _jsx(Typography, { color: theme.palette.text.success, fontWeight: "bold", children: decodeURI(crumbName) }) }, crumb));
    };
    var otherMenu = [
        {
            label: t('settings'),
            route: '/settings',
        },
        {
            label: t('knowledgeBaseManage'),
            route: '/knowledge-base',
        },
    ];
    if (location.pathname === '/') {
        var curmbName = (_b = menus.find(function (menu) { return menu.path == location.pathname; })) === null || _b === void 0 ? void 0 : _b.label;
        crumb = (_jsx(Link, { id: "".concat(curmbName, "_breadcrumb"), to: '', style: {
                textDecoration: 'none',
            }, children: _jsx(Typography, { color: theme.palette.text.success, fontWeight: "bold", children: curmbName }) }));
    }
    else {
        currentLink = [];
        crumb = location.pathname
            .split('/')
            .filter(function (ele) { return ele !== ''; })
            .flatMap(function (crumb) {
            var _a;
            var _menu = findCurrentMenu(menus, 0, crumb);
            var curmbName = _menu === null || _menu === void 0 ? void 0 : _menu.label;
            if (_menu === null || _menu === void 0 ? void 0 : _menu.parentId) {
                var menu = menus.find(function (x) { return x.id == (_menu === null || _menu === void 0 ? void 0 : _menu.parentId); });
                if (menu === null || menu === void 0 ? void 0 : menu.children) {
                    curmbName = "".concat(menu === null || menu === void 0 ? void 0 : menu.label, " > ").concat(menu === null || menu === void 0 ? void 0 : menu.children[0].label, " > ").concat(curmbName);
                }
            }
            //If pathname not match menu route
            if (!_menu) {
                curmbName =
                    ((_a = otherMenu.find(function (menu) { return menu.route.includes(crumb); })) === null || _a === void 0 ? void 0 : _a.label) ||
                        crumb;
            }
            currentLink.push(crumb);
            // Pages launched from Dashboard get their own clickable "Dashboard" crumb linking to "/"
            if (crumb === 'knowledge-base') {
                return [
                    _jsx(Link, { id: "Dashboard_breadcrumb", to: "/", style: { textDecoration: 'none' }, children: _jsx(Typography, { color: theme.palette.text.success, fontWeight: "bold", children: t('dashboard') }) }, "dashboard_breadcrumb"),
                    renderBreadcrumbLink(crumb, curmbName, currentLink),
                ];
            }
            var titleSubSettings = [];
            dummyMenu(t).forEach(function (x) {
                titleSubSettings.push(x.subCategorys);
            });
            if (crumb === 'settings') {
                _1.flattenDeep(titleSubSettings).forEach(function (x) {
                    if (x.id === id) {
                        curmbName = "".concat(curmbName, " > ").concat(x.title);
                    }
                });
            }
            return renderBreadcrumbLink(crumb, curmbName, currentLink);
        });
    }
    return (_jsxs(MuiBreadcrumbs, { "aria-label": "breadcrumb", separator: _jsx(Typography, { color: theme.palette.text.success, fontWeight: "bold", children: '>' }), children: [_jsx(Link, { to: "/", id: "Home_breadcrumb", style: {
                    textDecoration: 'none',
                }, children: _jsx(Typography, { color: theme.palette.text.success, fontWeight: "bold", children: t('home') }) }), crumb] }));
};
